import firebase from "firebase";
import "firebase/firestore";

export { getQuests };
async function getQuests() {
  const docs = await firebase
    .firestore()
    .collection("quests")
    .get();

  let datas = [];
  docs.forEach(function(doc) {
    let d = doc.data();
    d.ref = doc.ref;
    d.reference = doc.ref;
    d.id = doc.id;
    datas.push(d);
  });
  return datas;
}
